import { END_OF_DAY } from "./CommonEndpoint";

export const END_OF_DAY_TASKS_GET = `${END_OF_DAY}/tasks`;
export const END_OF_DAY_TASKS_UPDATE = `${END_OF_DAY}/tasks`;
export const END_OF_DAY_TASKS_CONFIGURATION = `${END_OF_DAY}/config`;
export const END_OF_DAY_CHECK = `${END_OF_DAY}/check`;
export const END_OF_DAY_RUN = `${END_OF_DAY}/process`;
